/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setBearerAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, BaseAPI, operationServerMap } from './base';
export const JSONPatchDTOInnerOpEnum = {
    Replace: 'replace',
    Add: 'add',
    Remove: 'remove'
};
export const MatcherMatcherTypeEnum = {
    Exact: 'EXACT',
    NotEmpty: 'NOT_EMPTY',
    Regex: 'REGEX',
    In: 'IN',
    All: 'ALL'
};
export const ModelErrorErrorCodeEnum = {
    _000: '000',
    _010: '010',
    _011: '011',
    _020: '020',
    _030: '030',
    _031: '031',
    _100: '100',
    _200: '200',
    _201: '201',
    _202: '202',
    _210: '210',
    _211: '211'
};
/**
 *
 * @export
 * @enum {string}
 */
export const StorageType = {
    Kiosk: 'KIOSK',
    Warehouse: 'WAREHOUSE',
    Unknown: 'UNKNOWN'
};
/**
 * StoragesControllerApi - axios parameter creator
 * @export
 */
export const StoragesControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Create one Storage
         * @param {string} authorization
         * @param {string} organizationId
         * @param {StorageDTO} storageDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStorage: (authorization_1, organizationId_1, storageDTO_1, ...args_1) => __awaiter(this, [authorization_1, organizationId_1, storageDTO_1, ...args_1], void 0, function* (authorization, organizationId, storageDTO, options = {}) {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createStorage', 'authorization', authorization);
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createStorage', 'organizationId', organizationId);
            // verify required parameter 'storageDTO' is not null or undefined
            assertParamExists('createStorage', 'storageDTO', storageDTO);
            const localVarPath = `/organizations/{organizationId}/storages`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(storageDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete one Storage
         * @param {string} authorization
         * @param {string} organizationId
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStorage: (authorization_1, organizationId_1, id_1, ...args_1) => __awaiter(this, [authorization_1, organizationId_1, id_1, ...args_1], void 0, function* (authorization, organizationId, id, options = {}) {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('deleteStorage', 'authorization', authorization);
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteStorage', 'organizationId', organizationId);
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteStorage', 'id', id);
            const localVarPath = `/organizations/{organizationId}/storages/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get one Storage
         * @param {string} authorization
         * @param {string} organizationId
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStorage: (authorization_1, organizationId_1, id_1, ...args_1) => __awaiter(this, [authorization_1, organizationId_1, id_1, ...args_1], void 0, function* (authorization, organizationId, id, options = {}) {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getStorage', 'authorization', authorization);
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getStorage', 'organizationId', organizationId);
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getStorage', 'id', id);
            const localVarPath = `/organizations/{organizationId}/storages/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get all Storage
         * @param {string} authorization
         * @param {string} organizationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStorages: (authorization_1, organizationId_1, ...args_1) => __awaiter(this, [authorization_1, organizationId_1, ...args_1], void 0, function* (authorization, organizationId, options = {}) {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getStorages', 'authorization', authorization);
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getStorages', 'organizationId', organizationId);
            const localVarPath = `/organizations/{organizationId}/storages`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update Storage with JSON Patch
         * @param {string} authorization
         * @param {string} organizationId
         * @param {string} id
         * @param {Array<JSONPatchDTOInner>} jSONPatchDTOInner JSON Patch for updating Storage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchStorage: (authorization_1, organizationId_1, id_1, jSONPatchDTOInner_1, ...args_1) => __awaiter(this, [authorization_1, organizationId_1, id_1, jSONPatchDTOInner_1, ...args_1], void 0, function* (authorization, organizationId, id, jSONPatchDTOInner, options = {}) {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('patchStorage', 'authorization', authorization);
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('patchStorage', 'organizationId', organizationId);
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchStorage', 'id', id);
            // verify required parameter 'jSONPatchDTOInner' is not null or undefined
            assertParamExists('patchStorage', 'jSONPatchDTOInner', jSONPatchDTOInner);
            const localVarPath = `/organizations/{organizationId}/storages/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(jSONPatchDTOInner, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Search Storages
         * @param {string} authorization
         * @param {string} organizationId
         * @param {StorageSearchDTO} [storageSearchDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchStorages: (authorization_1, organizationId_1, storageSearchDTO_1, ...args_1) => __awaiter(this, [authorization_1, organizationId_1, storageSearchDTO_1, ...args_1], void 0, function* (authorization, organizationId, storageSearchDTO, options = {}) {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('searchStorages', 'authorization', authorization);
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('searchStorages', 'organizationId', organizationId);
            const localVarPath = `/organizations/{organizationId}/storages/search`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(storageSearchDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * StoragesControllerApi - functional programming interface
 * @export
 */
export const StoragesControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = StoragesControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Create one Storage
         * @param {string} authorization
         * @param {string} organizationId
         * @param {StorageDTO} storageDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStorage(authorization, organizationId, storageDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createStorage(authorization, organizationId, storageDTO, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['StoragesControllerApi.createStorage']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Delete one Storage
         * @param {string} authorization
         * @param {string} organizationId
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStorage(authorization, organizationId, id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteStorage(authorization, organizationId, id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['StoragesControllerApi.deleteStorage']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get one Storage
         * @param {string} authorization
         * @param {string} organizationId
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStorage(authorization, organizationId, id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getStorage(authorization, organizationId, id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['StoragesControllerApi.getStorage']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get all Storage
         * @param {string} authorization
         * @param {string} organizationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStorages(authorization, organizationId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getStorages(authorization, organizationId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['StoragesControllerApi.getStorages']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Update Storage with JSON Patch
         * @param {string} authorization
         * @param {string} organizationId
         * @param {string} id
         * @param {Array<JSONPatchDTOInner>} jSONPatchDTOInner JSON Patch for updating Storage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchStorage(authorization, organizationId, id, jSONPatchDTOInner, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.patchStorage(authorization, organizationId, id, jSONPatchDTOInner, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['StoragesControllerApi.patchStorage']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Search Storages
         * @param {string} authorization
         * @param {string} organizationId
         * @param {StorageSearchDTO} [storageSearchDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchStorages(authorization, organizationId, storageSearchDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchStorages(authorization, organizationId, storageSearchDTO, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['StoragesControllerApi.searchStorages']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * StoragesControllerApi - factory interface
 * @export
 */
export const StoragesControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = StoragesControllerApiFp(configuration);
    return {
        /**
         *
         * @summary Create one Storage
         * @param {string} authorization
         * @param {string} organizationId
         * @param {StorageDTO} storageDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStorage(authorization, organizationId, storageDTO, options) {
            return localVarFp.createStorage(authorization, organizationId, storageDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete one Storage
         * @param {string} authorization
         * @param {string} organizationId
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStorage(authorization, organizationId, id, options) {
            return localVarFp.deleteStorage(authorization, organizationId, id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get one Storage
         * @param {string} authorization
         * @param {string} organizationId
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStorage(authorization, organizationId, id, options) {
            return localVarFp.getStorage(authorization, organizationId, id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Storage
         * @param {string} authorization
         * @param {string} organizationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStorages(authorization, organizationId, options) {
            return localVarFp.getStorages(authorization, organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update Storage with JSON Patch
         * @param {string} authorization
         * @param {string} organizationId
         * @param {string} id
         * @param {Array<JSONPatchDTOInner>} jSONPatchDTOInner JSON Patch for updating Storage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchStorage(authorization, organizationId, id, jSONPatchDTOInner, options) {
            return localVarFp.patchStorage(authorization, organizationId, id, jSONPatchDTOInner, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Search Storages
         * @param {string} authorization
         * @param {string} organizationId
         * @param {StorageSearchDTO} [storageSearchDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchStorages(authorization, organizationId, storageSearchDTO, options) {
            return localVarFp.searchStorages(authorization, organizationId, storageSearchDTO, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * StoragesControllerApi - object-oriented interface
 * @export
 * @class StoragesControllerApi
 * @extends {BaseAPI}
 */
export class StoragesControllerApi extends BaseAPI {
    /**
     *
     * @summary Create one Storage
     * @param {string} authorization
     * @param {string} organizationId
     * @param {StorageDTO} storageDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoragesControllerApi
     */
    createStorage(authorization, organizationId, storageDTO, options) {
        return StoragesControllerApiFp(this.configuration).createStorage(authorization, organizationId, storageDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete one Storage
     * @param {string} authorization
     * @param {string} organizationId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoragesControllerApi
     */
    deleteStorage(authorization, organizationId, id, options) {
        return StoragesControllerApiFp(this.configuration).deleteStorage(authorization, organizationId, id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get one Storage
     * @param {string} authorization
     * @param {string} organizationId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoragesControllerApi
     */
    getStorage(authorization, organizationId, id, options) {
        return StoragesControllerApiFp(this.configuration).getStorage(authorization, organizationId, id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Storage
     * @param {string} authorization
     * @param {string} organizationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoragesControllerApi
     */
    getStorages(authorization, organizationId, options) {
        return StoragesControllerApiFp(this.configuration).getStorages(authorization, organizationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update Storage with JSON Patch
     * @param {string} authorization
     * @param {string} organizationId
     * @param {string} id
     * @param {Array<JSONPatchDTOInner>} jSONPatchDTOInner JSON Patch for updating Storage
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoragesControllerApi
     */
    patchStorage(authorization, organizationId, id, jSONPatchDTOInner, options) {
        return StoragesControllerApiFp(this.configuration).patchStorage(authorization, organizationId, id, jSONPatchDTOInner, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Search Storages
     * @param {string} authorization
     * @param {string} organizationId
     * @param {StorageSearchDTO} [storageSearchDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoragesControllerApi
     */
    searchStorages(authorization, organizationId, storageSearchDTO, options) {
        return StoragesControllerApiFp(this.configuration).searchStorages(authorization, organizationId, storageSearchDTO, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * VendorsControllerApi - axios parameter creator
 * @export
 */
export const VendorsControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Create one Vendor
         * @param {string} authorization
         * @param {string} organizationId
         * @param {VendorDTO} vendorDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVendor: (authorization_1, organizationId_1, vendorDTO_1, ...args_1) => __awaiter(this, [authorization_1, organizationId_1, vendorDTO_1, ...args_1], void 0, function* (authorization, organizationId, vendorDTO, options = {}) {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createVendor', 'authorization', authorization);
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createVendor', 'organizationId', organizationId);
            // verify required parameter 'vendorDTO' is not null or undefined
            assertParamExists('createVendor', 'vendorDTO', vendorDTO);
            const localVarPath = `/organizations/{organizationId}/vendors`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(vendorDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete one Vendor
         * @param {string} authorization
         * @param {string} organizationId
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVendor: (authorization_1, organizationId_1, id_1, ...args_1) => __awaiter(this, [authorization_1, organizationId_1, id_1, ...args_1], void 0, function* (authorization, organizationId, id, options = {}) {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('deleteVendor', 'authorization', authorization);
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteVendor', 'organizationId', organizationId);
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteVendor', 'id', id);
            const localVarPath = `/organizations/{organizationId}/vendors/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get one Vendor
         * @param {string} authorization
         * @param {string} organizationId
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVendor: (authorization_1, organizationId_1, id_1, ...args_1) => __awaiter(this, [authorization_1, organizationId_1, id_1, ...args_1], void 0, function* (authorization, organizationId, id, options = {}) {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getVendor', 'authorization', authorization);
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getVendor', 'organizationId', organizationId);
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getVendor', 'id', id);
            const localVarPath = `/organizations/{organizationId}/vendors/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get all Vendors
         * @param {string} authorization
         * @param {string} organizationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVendors: (authorization_1, organizationId_1, ...args_1) => __awaiter(this, [authorization_1, organizationId_1, ...args_1], void 0, function* (authorization, organizationId, options = {}) {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getVendors', 'authorization', authorization);
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getVendors', 'organizationId', organizationId);
            const localVarPath = `/organizations/{organizationId}/vendors`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update Vendor with JSON Patch
         * @param {string} authorization
         * @param {string} organizationId
         * @param {string} id
         * @param {Array<JSONPatchDTOInner>} jSONPatchDTOInner JSON Patch for updating Vendor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchVendor: (authorization_1, organizationId_1, id_1, jSONPatchDTOInner_1, ...args_1) => __awaiter(this, [authorization_1, organizationId_1, id_1, jSONPatchDTOInner_1, ...args_1], void 0, function* (authorization, organizationId, id, jSONPatchDTOInner, options = {}) {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('patchVendor', 'authorization', authorization);
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('patchVendor', 'organizationId', organizationId);
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchVendor', 'id', id);
            // verify required parameter 'jSONPatchDTOInner' is not null or undefined
            assertParamExists('patchVendor', 'jSONPatchDTOInner', jSONPatchDTOInner);
            const localVarPath = `/organizations/{organizationId}/vendors/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(jSONPatchDTOInner, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Search Vendors
         * @param {string} authorization
         * @param {string} organizationId
         * @param {VendorSearchDTO} [vendorSearchDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchVendors: (authorization_1, organizationId_1, vendorSearchDTO_1, ...args_1) => __awaiter(this, [authorization_1, organizationId_1, vendorSearchDTO_1, ...args_1], void 0, function* (authorization, organizationId, vendorSearchDTO, options = {}) {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('searchVendors', 'authorization', authorization);
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('searchVendors', 'organizationId', organizationId);
            const localVarPath = `/organizations/{organizationId}/vendors/search`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(vendorSearchDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * VendorsControllerApi - functional programming interface
 * @export
 */
export const VendorsControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = VendorsControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Create one Vendor
         * @param {string} authorization
         * @param {string} organizationId
         * @param {VendorDTO} vendorDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVendor(authorization, organizationId, vendorDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createVendor(authorization, organizationId, vendorDTO, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['VendorsControllerApi.createVendor']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Delete one Vendor
         * @param {string} authorization
         * @param {string} organizationId
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVendor(authorization, organizationId, id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteVendor(authorization, organizationId, id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['VendorsControllerApi.deleteVendor']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get one Vendor
         * @param {string} authorization
         * @param {string} organizationId
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVendor(authorization, organizationId, id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getVendor(authorization, organizationId, id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['VendorsControllerApi.getVendor']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get all Vendors
         * @param {string} authorization
         * @param {string} organizationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVendors(authorization, organizationId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getVendors(authorization, organizationId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['VendorsControllerApi.getVendors']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Update Vendor with JSON Patch
         * @param {string} authorization
         * @param {string} organizationId
         * @param {string} id
         * @param {Array<JSONPatchDTOInner>} jSONPatchDTOInner JSON Patch for updating Vendor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchVendor(authorization, organizationId, id, jSONPatchDTOInner, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.patchVendor(authorization, organizationId, id, jSONPatchDTOInner, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['VendorsControllerApi.patchVendor']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Search Vendors
         * @param {string} authorization
         * @param {string} organizationId
         * @param {VendorSearchDTO} [vendorSearchDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchVendors(authorization, organizationId, vendorSearchDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchVendors(authorization, organizationId, vendorSearchDTO, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['VendorsControllerApi.searchVendors']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * VendorsControllerApi - factory interface
 * @export
 */
export const VendorsControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = VendorsControllerApiFp(configuration);
    return {
        /**
         *
         * @summary Create one Vendor
         * @param {string} authorization
         * @param {string} organizationId
         * @param {VendorDTO} vendorDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVendor(authorization, organizationId, vendorDTO, options) {
            return localVarFp.createVendor(authorization, organizationId, vendorDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete one Vendor
         * @param {string} authorization
         * @param {string} organizationId
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVendor(authorization, organizationId, id, options) {
            return localVarFp.deleteVendor(authorization, organizationId, id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get one Vendor
         * @param {string} authorization
         * @param {string} organizationId
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVendor(authorization, organizationId, id, options) {
            return localVarFp.getVendor(authorization, organizationId, id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Vendors
         * @param {string} authorization
         * @param {string} organizationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVendors(authorization, organizationId, options) {
            return localVarFp.getVendors(authorization, organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update Vendor with JSON Patch
         * @param {string} authorization
         * @param {string} organizationId
         * @param {string} id
         * @param {Array<JSONPatchDTOInner>} jSONPatchDTOInner JSON Patch for updating Vendor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchVendor(authorization, organizationId, id, jSONPatchDTOInner, options) {
            return localVarFp.patchVendor(authorization, organizationId, id, jSONPatchDTOInner, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Search Vendors
         * @param {string} authorization
         * @param {string} organizationId
         * @param {VendorSearchDTO} [vendorSearchDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchVendors(authorization, organizationId, vendorSearchDTO, options) {
            return localVarFp.searchVendors(authorization, organizationId, vendorSearchDTO, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * VendorsControllerApi - object-oriented interface
 * @export
 * @class VendorsControllerApi
 * @extends {BaseAPI}
 */
export class VendorsControllerApi extends BaseAPI {
    /**
     *
     * @summary Create one Vendor
     * @param {string} authorization
     * @param {string} organizationId
     * @param {VendorDTO} vendorDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorsControllerApi
     */
    createVendor(authorization, organizationId, vendorDTO, options) {
        return VendorsControllerApiFp(this.configuration).createVendor(authorization, organizationId, vendorDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete one Vendor
     * @param {string} authorization
     * @param {string} organizationId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorsControllerApi
     */
    deleteVendor(authorization, organizationId, id, options) {
        return VendorsControllerApiFp(this.configuration).deleteVendor(authorization, organizationId, id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get one Vendor
     * @param {string} authorization
     * @param {string} organizationId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorsControllerApi
     */
    getVendor(authorization, organizationId, id, options) {
        return VendorsControllerApiFp(this.configuration).getVendor(authorization, organizationId, id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Vendors
     * @param {string} authorization
     * @param {string} organizationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorsControllerApi
     */
    getVendors(authorization, organizationId, options) {
        return VendorsControllerApiFp(this.configuration).getVendors(authorization, organizationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update Vendor with JSON Patch
     * @param {string} authorization
     * @param {string} organizationId
     * @param {string} id
     * @param {Array<JSONPatchDTOInner>} jSONPatchDTOInner JSON Patch for updating Vendor
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorsControllerApi
     */
    patchVendor(authorization, organizationId, id, jSONPatchDTOInner, options) {
        return VendorsControllerApiFp(this.configuration).patchVendor(authorization, organizationId, id, jSONPatchDTOInner, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Search Vendors
     * @param {string} authorization
     * @param {string} organizationId
     * @param {VendorSearchDTO} [vendorSearchDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorsControllerApi
     */
    searchVendors(authorization, organizationId, vendorSearchDTO, options) {
        return VendorsControllerApiFp(this.configuration).searchVendors(authorization, organizationId, vendorSearchDTO, options).then((request) => request(this.axios, this.basePath));
    }
}
